export const GET_YZ_REFS_SUCCESS = 'GET_YZ_REFS_SUCCESS';
export const CHOOSE_YZ_REFS_SUCCESS = 'CHOOSE_YZ_REFS_SUCCESS';
export const LOADING_MESSAGE = '请稍等...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
